import axios from "axios";
import FormUpload from "./FormUpload";
import React, { Fragment, useState, useEffect } from "react";
import styles from "../../assets/css/OPDCNews.module.css";
import { GetCookieToken } from "../Cookie/GetCookie";
import LoadingData from "../TESTPage/LoadingData";
import {
    Alert, Button, Card, CardBody, Form, FormFeedback, FormGroup, FormText, Input, Label, Offcanvas, OffcanvasBody, OffcanvasHeader,
    Spinner, Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";

const API_URL = process.env.REACT_APP_API_CORS;

function EditNews(props) {
    const { id, refreshDataTable } = props;
    const [fileUpload, setFileUpload] = useState([]);
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const [thisData, setThisData] = useState([]);
    const [modalDel, setModalDel] = useState(false);
    const [dataEdit, setDataEdit] = useState({ heading: '', content: '' });

    const toggleDel = () => setModalDel(!modalDel);

    const token = GetCookieToken("userToken");

    const fetchThisData = async () => {

        setLoading(true);
        const url = `${API_URL}/api/opdcNews/datatable`;
        const params = new URLSearchParams({
            page: 1,
            size: 20,
            "order[0]": "opdc_news_id",
            "order[1]": "DESC",
            "filter[opdc_news_id][0]": id,
        });
        const config = { headers: { Authorization: `Bearer ${token}`, }, params };
        await axios.get(url, config).then(response => {
            setThisData(response.data.result[0]);
            setDataEdit({ heading: response.data.result[0]?.heading, content: response.data.result[0]?.content });
        }).catch(error => console.error("Error:", error));
        setLoading(false);

    };

    const deleteImg = async (e, key) => {
        setLoading(true);
        thisData.photo = thisData.photo.filter((val, index) => val.opdc_news_photo_id !== key);
        setThisData(thisData);
        const url = `${API_URL}/api/opdcNews/image/${key}`;
        const config = { headers: { Authorization: `Bearer ${token}`, } };
        await axios.delete(url, config).then(async response => { });
        setLoading(false);
    }

    const toggleRightCanvas = () => {
        setOpen(!open);
    };

    const handleFile = value => {
        setFileUpload(value);
    };

    const deleteRow = async () => {
        const url = `${API_URL}/api/opdcNews/${id}`;
        const config = { headers: { Authorization: `Bearer ${token}`, } };
        await axios.delete(url, config).then(async response => {
            setModalDel(false);
            await refreshDataTable();
        });
    }

    const handleSubmit = async () => {
        setLoading(true);
        const url = `${API_URL}/api/opdcNews/${id}`;
        const config = { headers: { Authorization: `Bearer ${token}`, } };
        await axios.put(url, { ...dataEdit }, config).then(async response => {
            await refreshDataTable();
        }).catch(error => console.error("Error:", error));

        if (fileUpload?.length > 0) {
            await fileUpload?.map(async (x) => {
                let url = `${API_URL}/api/opdcNews/image/${id}`;
                let formData = new FormData();
                formData.append("file", x);
                await fetch(url, {
                    method: "POST", headers: { Authorization: `Bearer ${token}`, },
                    body: formData,
                });
            })
        }
        setLoading(false);
    }

    return (
        <Fragment>
            <Button className="btn-sm text-nowrap" color="warning" onClick={toggleRightCanvas}>
                <i className="fa-solid fa-pen-to-square"></i> แก้ไข
            </Button>
            {" "}
            <Button className="btn-sm text-nowrap" color="danger" onClick={toggleDel} >
                <i className="fa-solid fa-trash"></i> ลบ
            </Button>

            <Modal isOpen={modalDel} toggle={toggleDel} size="sm" centered={true}>
                <ModalHeader toggle={toggleDel}>ต้องการลบใชหรือไม่ ?</ModalHeader>
                <ModalFooter>
                    <Button color="danger" onClick={deleteRow}>
                        <i className="fa-solid fa-trash"></i> ตกลง
                    </Button>{' '}
                    <Button color="secondary" onClick={toggleDel}>
                        ยกเลิก
                    </Button>
                </ModalFooter>
            </Modal>

            <Offcanvas
                style={{ border: "none", width: '1000px' }}
                autoFocus
                direction="end"
                isOpen={open}
                onClosed={refreshDataTable}
                toggle={toggleRightCanvas}
                fade
                className="fade"
                onOpened={fetchThisData}
            >
                <OffcanvasHeader className="position-relative" style={{ background: "#2a3042", color: "#ffffff" }}>
                    <i className="fa-regular fa-newspaper pe-2" style={{ color: "#ffffff" }}></i>
                    แก้ไขข่าว
                    <div className={"position-absolute top-0 end-0"}>
                        <i className={`fa-sharp fa-solid fa-circle-xmark pt-3 pe-3 h4 ${styles.pointer}`} onClick={toggleRightCanvas}></i>
                    </div>
                </OffcanvasHeader>
                <OffcanvasBody>

                    {loading ? (
                        <div style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: "400px",
                        }}>
                            <LoadingData />
                        </div>
                    ) : (
                        <Card>
                            <CardBody>
                                <Form
                                    onSubmit={async e => {
                                        e.preventDefault();
                                        await handleSubmit();
                                    }}
                                >
                                    <FormGroup>
                                        <Label>
                                            <b>หัวข้อข่าว</b>
                                        </Label>
                                        <Input
                                            defaultValue={thisData.heading}
                                            placeholder="หัวข้อข่าว"
                                            type="text"
                                            onChange={async (e) => { setDataEdit({ ...dataEdit, heading: e.target.value }) }}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label><b>เนื้อหาข่าว</b></Label>
                                        <Input
                                            defaultValue={thisData.content}
                                            placeholder="เนื้อหาข่าว"
                                            type="textarea"
                                            rows={20}
                                            onChange={async (e) => { setDataEdit({ ...dataEdit, content: e.target.value }) }}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <ul className="list-inine ps-0 mb-4" >
                                            {
                                                thisData.photo && thisData.photo.map(x => {
                                                    return (
                                                        <li className="list-inline-item pe-3">
                                                            <div className="position-relative">
                                                                <div className={"position-absolute top-0 end-0"}>
                                                                    <i key={x.opdc_news_photo_id} onClick={e => deleteImg(e, x.opdc_news_photo_id)} className={`fa-sharp fa-solid fa-circle-xmark pt-1 pe-1 h4 shadow ${styles.pointer} ${styles.text_red}`} ></i>
                                                                </div>
                                                                <img src={`${x.file_img}`.replace('./public', `${API_URL}`)} className="rounded" style={{ maxWidth: '230px', maxheight: "230px" }} alt="" />
                                                            </div>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="exampleFile">ไฟล์</Label>
                                        <FormUpload onFileUpload={handleFile} />
                                    </FormGroup>
                                    <Button color="success" type="submit">
                                        <i class="fa-solid fa-floppy-disk-pen"></i> บันทึก
                                    </Button>
                                </Form>
                            </CardBody>
                        </Card>
                    )}
                </OffcanvasBody>
            </Offcanvas>
        </Fragment >
    );
}

export default EditNews;
